import {Option} from 'platform/components';

import {isNil} from 'ramda';

import {SeriesResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

export const getOptionsFromSeries = (
  series: Pick<SeriesResponseBody, 'id' | 'name' | 'type'>[] | Nullish,
  type: SeriesResponseBody['type']
): Option[] => {
  if (isNil(series)) {
    return [];
  }

  return series
    .filter((serie) => serie.type === type)
    .map((serie) => ({
      label: serie.name,
      value: serie.id,
    }));
};
